import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NotFound = ({ setShowNavbar }) => {
  const navigate = useNavigate();

  // إخفاء الـ Navbar لما الصفحة دي تظهر
  useEffect(() => {
    if (setShowNavbar) setShowNavbar(false);
    return () => {
      if (setShowNavbar) setShowNavbar(true);
    };
  }, [setShowNavbar]);

  const S = {
    page: {
      minHeight: '100vh',
      background: '#0d1117',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem 2rem',
      position: 'relative',
      overflow: 'hidden',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
    },
    grid: {
      position: 'absolute', inset: 0,
      backgroundImage:
        'linear-gradient(rgba(99,102,241,0.06) 1px,transparent 1px),' +
        'linear-gradient(90deg,rgba(99,102,241,0.06) 1px,transparent 1px)',
      backgroundSize: '40px 40px',
    },
    glow: {
      position: 'absolute', top: '-120px', left: '50%',
      transform: 'translateX(-50%)',
      width: 500, height: 400,
      background: 'radial-gradient(ellipse at center,rgba(99,102,241,0.15) 0%,transparent 70%)',
      pointerEvents: 'none',
    },
    wrap: {
      position: 'relative', zIndex: 1,
      maxWidth: 480, width: '100%', textAlign: 'center',
    },
    numRow: {
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: 8, marginBottom: '2rem',
    },
    num4: {
      fontSize: 96, fontWeight: 800, lineHeight: 1, color: '#6366f1',
    },
    num0: {
      width: 86, height: 86, borderRadius: '50%',
      border: '5px solid #6366f1',
      background: 'rgba(99,102,241,0.08)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    badge: {
      display: 'inline-flex', alignItems: 'center', gap: 6,
      background: 'rgba(99,102,241,0.15)',
      border: '1px solid rgba(99,102,241,0.3)',
      borderRadius: 20, padding: '4px 14px',
      fontSize: 11, fontWeight: 700, color: '#a5b4fc',
      marginBottom: '1.25rem', letterSpacing: '0.06em',
    },
    badgeDot: {
      width: 6, height: 6, borderRadius: '50%', background: '#6366f1',
    },
    h1: {
      fontSize: 28, fontWeight: 800, color: '#f8fafc',
      margin: '0 0 0.75rem', letterSpacing: '-0.5px',
    },
    desc: {
      fontSize: 15, color: '#94a3b8', lineHeight: 1.7,
      margin: '0 0 2rem', maxWidth: 380,
      marginLeft: 'auto', marginRight: 'auto',
    },
    actions: {
      display: 'flex', flexDirection: 'column', gap: 10, marginBottom: '2rem',
    },
    btnPrimary: {
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      padding: '13px 24px',
      background: '#0D47A1', color: '#fff',
      border: 'none', borderRadius: 12,
      fontSize: 14, fontWeight: 600, cursor: 'pointer',
      textDecoration: 'none', fontFamily: 'inherit',
      transition: 'background 0.15s, transform 0.1s',
    },
    btnGhost: {
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      padding: '12px 24px',
      background: 'rgba(255,255,255,0.04)', color: '#94a3b8',
      border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12,
      fontSize: 14, fontWeight: 500, cursor: 'pointer',
      fontFamily: 'inherit', width: '100%',
      transition: 'background 0.15s',
    },
    sep: {
      display: 'flex', alignItems: 'center', gap: 12, marginBottom: '1.5rem',
    },
    sepLine: { flex: 1, height: 1, background: 'rgba(255,255,255,0.07)' },
    sepTxt: { fontSize: 12, color: '#475569', whiteSpace: 'nowrap' },
    grid3: {
      display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10,
    },
    scItem: {
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', gap: 8, padding: '16px 10px',
      background: 'rgba(255,255,255,0.03)',
      border: '1px solid rgba(255,255,255,0.07)',
      borderRadius: 12, textDecoration: 'none',
      transition: 'background 0.15s, border-color 0.15s, transform 0.15s',
    },
    scLabel: { fontSize: 12, color: '#64748b', fontWeight: 500 },
    footer: {
      fontSize: 11, color: '#334155', marginTop: '2rem', letterSpacing: '0.04em',
    },
  };

  const IconHome = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  );

  const IconChevronLeft = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  );

  const IconEyeOff = () => (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  );

  

  return (
    <div style={S.page}>
      <div style={S.grid} />
      <div style={S.glow} />

      <div style={S.wrap}>
        {/* 404 number */}
        <div style={S.numRow}>
          <span style={S.num4}>4</span>
          <div style={S.num0}>
            <IconEyeOff />
          </div>
          <span style={S.num4}>4</span>
        </div>

        {/* Badge */}
        <div style={S.badge}>
          <div style={S.badgeDot} />
          PAGE NOT FOUND
        </div>

        <h1 style={S.h1}>Lost in the property maze</h1>
        <p style={S.desc}>
          Looks like this address doesn't exist in our system. The page may have moved, been deleted, or never existed.
        </p>

        {/* Action buttons */}
        <div style={S.actions}>
          <Link to="/" style={S.btnPrimary}
            onMouseEnter={(e) => { e.currentTarget.style.background='#0D47A1'; e.currentTarget.style.transform='translateY(-1px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background='#0D47A1'; e.currentTarget.style.transform='none'; }}
          >
            <IconHome /> Back to home
          </Link>
          <button style={S.btnGhost} onClick={() => navigate(-1)}
            onMouseEnter={(e) => { e.currentTarget.style.background='rgba(255,255,255,0.07)'; e.currentTarget.style.color='#e2e8f0'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background='rgba(255,255,255,0.04)'; e.currentTarget.style.color='#94a3b8'; }}
          >
            <IconChevronLeft /> Go back
          </button>
        </div>

      

       

        <div style={S.footer}>Realatix CRM &nbsp;·&nbsp; Error 404</div>
      </div>
    </div>
  );
};

export default NotFound;
